// extracted by mini-css-extract-plugin
module.exports = {"addToCartBtnContainer":"VbPqrS","addToCartBtn":"AlpQKX","dummyTextForLoadingWidth":"RYPDxA"};